export default __webpack_public_path__ + "static/media/rs-arte-3.ec57ce1f.webp";